function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.663,5.999 L11.864,0.799 C12.047,0.616 12.047,0.319 11.864,0.136 C11.681,-0.047 11.384,-0.047 11.201,0.136 L6.000,5.336 L0.799,0.136 C0.616,-0.047 0.319,-0.047 0.136,0.136 C-0.047,0.319 -0.047,0.616 0.136,0.799 L5.337,5.999 L0.136,11.200 C-0.047,11.383 -0.047,11.680 0.136,11.863 C0.228,11.954 0.348,12.000 0.468,12.000 C0.588,12.000 0.708,11.954 0.799,11.863 L6.000,6.662 L11.201,11.863 C11.292,11.954 11.412,12.000 11.532,12.000 C11.652,12.000 11.772,11.954 11.864,11.863 C12.047,11.680 12.047,11.383 11.864,11.200 L6.663,5.999 Z"
});

var SvgMobileClose = function SvgMobileClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMobileClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile-close.156a555a.svg";
export { ForwardRef as ReactComponent };